/**
 * Build the Google Maps directions URL from the property to the employer.
 * Mirrors Angular's resident-application Map link, which renders only when the
 * property address, the employer street address, and the employer city are all
 * present (`*ngIf="getPropertyAddress() && employer_street_address && employer_city"`).
 * Returns '' when the link should be hidden.
 */
export function buildEmployerMapHref(
  propertyAddress: string | undefined,
  employerAddress: string | undefined,
  employerCity: string | undefined,
): string {
  if (
    !propertyAddress?.trim() ||
    !employerAddress?.trim() ||
    !employerCity?.trim()
  ) {
    return ''
  }
  return `https://www.google.com/maps/dir/${encodeURIComponent(
    propertyAddress.trim(),
  )}/${encodeURIComponent(employerAddress.trim())}`
}
